const state = {
  users: [],
  userRoles: []
};

export default {
  state
};
